// export const baseURL = "https://app-ci-ithelpdesk-api-dev.azurewebsites.net";

// export const baseURL = "http://localhost:3000";
export const baseURL = "https://itsupport.ramcides.com/admin";
// export const baseURL = "https://app-ci-ithelpdesk-api-prod.vercel.app";

export const baseURL1 = "https://storciithelpdeskprod.blob.core.windows.net/ithelpdeskprod";

const baseURLAPI = baseURL + "/api";

export const todoAPI = baseURLAPI + "/todo";
export const statusAPI = baseURLAPI + "/status";
export const usersAPI = baseURLAPI + "/users";
export const assetsAPI = baseURLAPI + "/assets";
export const ticketAPI = baseURLAPI + "/ticket";
export const ticket1API = baseURLAPI + "/ticket1";
export const userDashboardAPI = baseURLAPI + "/userdashboard";
export const agentDashboardAPI = baseURLAPI + "/agentdashboard";
export const agentVendorAPI = baseURLAPI + "/vendor";
export const agentUserAPI = baseURLAPI + "/agentusers";
export const agentUser1API = baseURLAPI + "/agentusers1";
export const loginAPI = baseURLAPI + "/login";
export const forgotPasswordAPI = baseURLAPI + "/forgot_password";
export const serviceLevelAgreementsAPI = baseURLAPI + "/service_level_agreements";
export const emailConfigurationAPI = baseURLAPI + "/email_configuration";


export const userData = JSON.parse(localStorage.getItem("user"));
const bearerToken = (userData === null) ? "" : userData.token
export const config = {
  method: "",
  url: "",
  mode: "cors",
  headers: {
    "Content-Type": "application/json",
    Authorization: "Bearer " + bearerToken,
  },
  data: [],
};

export const validEmail = new RegExp(
  '^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$'
);

// Helper to read meData from localStorage
export const getMeData = () => JSON.parse(localStorage.getItem("meData"));
